import { IMAGE } from '../elements/assets'
import { LINK_TITLE } from '../elements/link'

export const RESOURCES = `
...on resources_Entry {
  id
  typeHandle

  backgroundColor
  heading {
    html
  }
  description: text
  ${ LINK_TITLE }
  backgroundColor
  layoutResources

  posts: blogPosts {
    ... on blogPost_Entry {
      id
      title
      description
      tags {
        title
      }

      url
      ${ IMAGE }
    }

    ... on resource_Entry {
      id
      title
      seomatic {
        metaTagContainer
      }
      url
      ${ IMAGE }
    }

    ... on customer_Entry {
      id
      title
      seomatic {
        metaTagContainer
      }
      url
      ${ IMAGE }
    }



    ... on learn_Entry {
      id
      title
      description
      seomatic {
        metaTagContainer
      }
      url
      ${ IMAGE }
    }

    ... on productUpdate_Entry {
      id
      title
      description
      tags {
        title
      }
      seomatic {
        metaTagContainer
      }
      url
      ${ IMAGE }
    }

    ... on perspective_Entry {
      id
      title
      description
      seomatic {
        metaTagContainer
      }
      url
      ${ IMAGE }
    }
  }
}
`